import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (data) {
  const { email, password, isDoctor } = data;

  // Dynamically change the URL based on the doctor status
  const url = isDoctor ? "/doctorOffice/login" : "/user/login";

  return fetch({
    data: { email, password },
    method: "post",
    url: url,
  });
};
AuthService.register = function (data) {
  return fetch({
    data: data,
    method: "post",
    url: "/doctorOffice/register",
  });
};

AuthService.requestSubscription = function (data) {
  return fetch({
    data,
    method: "post",
    url: "/doctorOffice/subscription/request",
  });
};

AuthService.getSpecialities = function (params = {}) {
  return fetch({
    method: "get",
    url: "/speciality/getAll",
    params,
  });
};

export default AuthService;
